import { render } from "./login-form.vue?vue&type=template&id=3aff7128&scoped=true"
import script from "./login-form.vue?vue&type=script&lang=js"
export * from "./login-form.vue?vue&type=script&lang=js"

import "./login-form.vue?vue&type=style&index=0&id=3aff7128&lang=less&scoped=true"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aff7128"]])

export default __exports__